var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9406 6.06717L7.94058 16.0672C7.88254 16.1253 7.81361 16.1714 7.73773 16.2028C7.66186 16.2343 7.58053 16.2505 7.49839 16.2505C7.41626 16.2505 7.33493 16.2343 7.25906 16.2028C7.18318 16.1714 7.11425 16.1253 7.05621 16.0672L2.68121 11.6922C2.56393 11.5749 2.49805 11.4158 2.49805 11.25C2.49805 11.0841 2.56393 10.9251 2.68121 10.8078C2.79848 10.6905 2.95754 10.6246 3.12339 10.6246C3.28925 10.6246 3.44831 10.6905 3.56558 10.8078L7.49839 14.7414L17.0562 5.18279C17.1735 5.06552 17.3325 4.99963 17.4984 4.99963C17.6642 4.99963 17.8233 5.06552 17.9406 5.18279C18.0579 5.30007 18.1237 5.45913 18.1237 5.62498C18.1237 5.79083 18.0579 5.94989 17.9406 6.06717Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.fbcb25c85297478ab22b23ed7401d830.svg";
export { ForwardRef as ReactComponent };